import { Icon } from '@chakra-ui/react';

export default function SFChatBubblesIconOutlined(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width={6}
      height='19px'
      fill='currentColor'
      viewBox='0 0 24 19'
      {...props}
    >
      <path d='M12.531 15.46c-1.633 0-2.703-.64-3.164-1.835l-2.656 2.36c-.477.413-.742.617-1.125.617-.547 0-.852-.383-.852-.985v-2.039H4.36c-2.328 0-3.578-1.281-3.578-3.57V4.016c0-2.29 1.25-3.578 3.578-3.578h10.063C16.75.438 18 1.727 18 4.015v.367h1.79c2.25 0 3.429 1.21 3.429 3.43v4.226c0 2.211-1.18 3.422-3.43 3.422h-.164v1.875c0 .594-.305.977-.844.977-.375 0-.633-.211-1.11-.618l-2.608-2.234zm-6.625-2.546v2.258l2.5-2.477c.235-.242.422-.336.703-.36 0-.093-.007-.194-.007-.296V7.813c0-2.22 1.18-3.43 3.43-3.43h4.21v-.36c0-1.523-.75-2.328-2.32-2.328H4.359c-1.578 0-2.32.805-2.32 2.328V10c0 1.523.742 2.32 2.32 2.32h.961c.422 0 .586.164.586.594m6.649 1.29h2.46c.32 0 .54.085.797.327l2.641 2.36v-2.047c0-.438.266-.64.602-.64h.718c1.524 0 2.188-.72 2.188-2.188V7.828c0-1.46-.664-2.187-2.188-2.187h-7.218c-1.532 0-2.188.726-2.188 2.187v4.195c0 1.461.656 2.18 2.188 2.18' />
    </Icon>
  );
}
